<template>
  <div class="no-auth">
    <div class="content">
      <div class="content-left">
        <img :src="platformInfo.noAuthImg" class="content-img" />
      </div>
      <div class="content-right">
        <div class="content-text">抱歉</div>
        <div class="content-text">您没有权限访问该页面</div>
        <!-- <div class="content-text">
          <span>{{ status.time }}秒后将自动返回</span>
        </div>
        <div class="content-button">
          <span class="skip-button" @click="skip">立即跳转</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, reactive, inject, ref, onMounted } from "vue";
import router from "@/router";
const platformInfo = inject("platformInfo");

// const status = reactive({
//   time: 5,
// });

// let timer = setInterval(() => {
//   status.time = status.time - 1;
//   if (status.time == 0) {
//     clearTimeout(timer);
//     router.push("/");
//   }
// }, 1000);

// const skip = () => {
//   router.push("/");
// };

// onBeforeUnmount(() => {
//   clearTimeout(timer);
// });
</script>

<style lang="scss" scoped>
.no-auth {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 50%;
    height: 50%;
    .content-left {
      display: flex;
      align-items: center;
      justify-content: center;
      .content-img {
        position: relative;
        top: -15px;
        width: 500px;
      }
    }
    .content-right {
      flex: 1;
      margin-left: 50px;
      text-align: left;
      .content-text {
        font-size: 18px;
        line-height: 40px;
        white-space: nowrap;
      }
      .content-button {
        line-height: 40px;
        .skip-button {
          font-size: 18px;
          font-weight: 550;
          cursor: pointer;
          color: $theme-color;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .no-auth {
    .content {
      flex-direction: column;
      .content-left {
        .content-img {
          width: 300px;
        }
      }
      .content-right {
      }
    }
  }
}
</style>
